import styled from 'styled-components';

export const SmallText = styled.span`
  display: block;
  font-size: ${({ theme }) => theme.font.size.small};
`;
